let csrfToken = sessionStorage.getItem('soliwoda.csrf') || '';

async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  if (options.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  if (csrfToken && !['GET', 'HEAD'].includes((options.method || 'GET').toUpperCase())) {
    headers.set('X-CSRF-Token', csrfToken);
  }
  const response = await fetch(path, { ...options, headers, credentials: 'same-origin' });
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : null;
  if (!response.ok) {
    const error = new Error(payload?.detail || `Request failed (${response.status})`);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload;
}

export const apiClient = {
  publicState: () => request('/api/site'),
  session: async () => {
    const payload = await request('/api/auth/session');
    if (payload.csrfToken) {
      csrfToken = payload.csrfToken;
      sessionStorage.setItem('soliwoda.csrf', csrfToken);
    }
    return payload;
  },
  login: async (username, password) => {
    const payload = await request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
    csrfToken = payload.csrfToken;
    sessionStorage.setItem('soliwoda.csrf', csrfToken);
    return payload;
  },
  logout: async () => {
    const payload = await request('/api/auth/logout', { method: 'POST' });
    csrfToken = '';
    sessionStorage.removeItem('soliwoda.csrf');
    return payload;
  },
  state: () => request('/api/admin/state'),
  save: (tree, action, baseVersion) => request('/api/admin/state', {
    method: 'PUT',
    body: JSON.stringify({ tree, action, baseVersion }),
  }),
  undo: () => request('/api/admin/undo', { method: 'POST' }),
  redo: () => request('/api/admin/redo', { method: 'POST' }),
  history: () => request('/api/admin/history?limit=60'),
};
